<div class="h-full flex flex-col table-container-general">
  <div class="table-container">
    <div class="sroll-table pt-2 pb-3 overflow-y-auto">
      @if (headers.length > 0) {
        <table mat-table [dataSource]="dataSource" class="w-full">
          @for (header of headers; track header; let indexColum = $index) {
            <!-- Iterar dinámicamente las columnas -->
            <ng-container
              [matColumnDef]="header.value"
              [sticky]="isSticky && indexColum === 0 && !isMobile"
              [stickyEnd]="isStickyEnd && indexColum === headers.length - 1 && !isMobile"
            >
              <!-- HEADER -->
              <th
                mat-header-cell
                *matHeaderCellDef
                class="min-w-37.5 text-center text-sm font-bold bg-(--comp-table-header-bg)!"
              >
                <div class="text-center font-semibold">
                  {{ header.description }}
                </div>
              </th>

              <!-- CELL -->
              <td
                mat-cell
                *matCellDef="let element; let indexFila = index"
                class="min-w-37.5 text-center! text-sm"
              >
                @if (indexColum === 0) {
                  @switch (true) {
                    @case (buttonEvent && !checkEvent) {
                      <button
                        mat-button
                        class="button-general-table w-auto px-2"
                        (click)="emitterButton(element[header.value], element)"
                      >
                        <mat-icon>article</mat-icon>
                        {{ element[header.value] }}
                      </button>
                    }

                    @case (!buttonEvent && checkEvent) {
                      <mat-checkbox
                        (change)="updateElement(element, header.value, $event.checked)"
                      />
                    }

                    @default {
                      <ng-container
                        *ngTemplateOutlet="
                          cellValue;
                          context: { element, header: { value: header.value }, indexColum }
                        "
                      />
                    }
                  }
                } @else if (indexColum === headers.length - 1 && menuButton.length > 0) {
                  <div>
                    @for (button of menuButton; track button) {
                      <button
                        mat-button
                        class="button-general-table w-auto! px-4!"
                        (click)="endEmitter(element)"
                      >
                        @if (button.icon) {
                          <mat-icon>{{ button.icon }}</mat-icon>
                        }
                        {{ button.text }}
                      </button>
                    }
                  </div>
                } @else {
                  <ng-container
                    *ngTemplateOutlet="
                      cellValue;
                      context: { element, header: { value: header.value }, indexColum }
                    "
                  />
                }
              </td>
            </ng-container>

            <!-- TEMPLATE REUTILIZABLE -->
            <ng-template
              #cellValue
              let-element="element"
              let-header="header"
              let-indexColum="indexColum"
            >
              @if (isBoolean(element[header.value])) {
                <div class="flex justify-center items-center">
                  <mat-icon
                    class="w-6! h-6! text-[24px]!"
                    [ngClass]="
                      element[header.value]
                        ? 'text-(--brand-verde-exito)!'
                        : 'text-(--brand-rojo-error)!'
                    "
                  >
                    {{ element[header.value] ? 'check_circle' : 'cancel' }}
                  </mat-icon>
                </div>
              } @else if (header.value.includes('$')) {
                {{ element[header.value] | currency: 'MXN' : 'symbol' : '1.2-2' }}
              } @else {
                {{ element[header.value] ?? element[indexColum] }}
              }
            </ng-template>
          }

          <!-- Filas -->
          <tr mat-header-row *matHeaderRowDef="headerKeys"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: headerKeys; let indexFila = index"
            class="table-row"
          ></tr>
        </table>
      }
    </div>
  </div>
</div>
